import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e292be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "t_name" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "cn" }, "目录"),
  /*#__PURE__*/_createElementVNode("p", { class: "en" }, "contents")
], -1))
const _hoisted_2 = { class: "detail" }
const _hoisted_3 = { class: "index" }
const _hoisted_4 = {
  key: 0,
  class: "child"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "global_hr" }, null, -1))

import { watch, withDefaults } from 'vue';

type CataLogueType = Array<{
  title: string;
  num: number;
  child: CataLogueType;
}>;

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-catalogue-1',
  props: {
    taskSum: { default: 1 },
    catalogue: {}
  },
  emits: ['catalogueFinish'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
watch(
  () => props.catalogue,
  () => {
    emits('catalogueFinish');
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, " 本报告所依赖数据都来自于线上或线下真实发生的行为所产生的数据，本次用于生成报告的数据为 " + _toDisplayString(_ctx.taskSum) + " 份。 ", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogue, ({ title, child, num }, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: index
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(`${index + 1}`.padStart(2, '0')), 1),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(title), 1),
          (Array.isArray(child))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child, ({ title }, childIndex) => {
                  return (_openBlock(), _createElementBlock("p", { key: childIndex }, _toDisplayString(title), 1))
                }), 128)),
                (child.length == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(`${num}`.padStart(2, '0')), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString([child[0].num, child.slice(-1)[0].num]
              .map(num => `${num}`.padStart(2, '0'))
              .join('-')), 1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _hoisted_7
  ], 64))
}
}

})